module.exports = require("./ff-Latn");